import axios, { type AxiosResponse } from 'axios'

import type { PaginatedResponse } from '@/api/schemas/common/pagination'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'
import type { CooperantDeliveryStatus } from '@/types/domain/orders/cooperant'

export type CooperantDeliveryStatusesResponse = PaginatedResponse<CooperantDeliveryStatus>

class CooperantDeliveryStatusesQueries {
    fetchAll(): Promise<AxiosResponse<CooperantDeliveryStatusesResponse>> {
        return axios.get<CooperantDeliveryStatusesResponse>(API_ENDPOINTS.DELIVERIES.COOPERANT_STATUSES)
    }
}

export default new CooperantDeliveryStatusesQueries()
